"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class StatInterpreter {
    constructor() {
        this.lastTimestamp = 0;
        this.lastBytes = 0;
        this.lastPackets = 0;
        this.inboundTracks = {};
    }
    updateStats(stats) {
        this.lastTimestamp = stats.get("timestamp");
        this.lastBytes = this.getStat(stats, "bytesReceived");
        this.lastPackets = this.getStat(stats, "packetsReceived");
        stats.forEach((value, key) => {
            if (value.type == "inbound-rtp") {
                let last = this.inboundTracks[value.id];
                let bitrate = 0;
                if (last != null) {
                    bitrate = Math.round((8 * (value.bytesReceived - last.bytesReceived)) / (value.timestamp - last.timestamp));
                }
                const newInbound = {
                    id: value.id,
                    kind: value.kind,
                    packetsReceived: value.packetsReceived,
                    packetsLost: value.packetsLost,
                    jitter: value.jitter,
                    bytesReceived: value.bytesReceived,
                    bitrate: bitrate,
                    timestamp: value.timestamp,
                };
                this.inboundTracks[value.id] = newInbound;
                // console.log(newInbound)
                // console.log(value)
            }
            // console.log(value)
        });
    }
    getStatsReport() {
        return {
            timestamp: this.lastTimestamp,
            bytes: this.lastBytes,
            packets: this.lastPackets,
            inbound_tracks: this.inboundTracks,
        };
    }
    getStat(stats, statName) {
        let stat = stats.get(statName);
        if (stat == null) {
            return 0;
        }
        return stat[statName];
    }
}
exports.default = StatInterpreter;
